import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const FormControlHelpText = /*@__PURE__*/ proxyCustomElement(class FormControlHelpText extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        if (!this.helpText) {
            return null;
        }
        return (h("small", { class: 'form-text text-muted', id: `form-help-text-${this.name}` }, this.helpText));
    }
}, [0, "form-control-help-text", {
        "helpText": [1, "help-text"],
        "name": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-help-text"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, FormControlHelpText);
            }
            break;
    } });
}
defineCustomElement();

export { FormControlHelpText as F, defineCustomElement as d };
